#import "../../../power-ai/timeline-summary/graphql/fragments/entity-summary-fragment.graphql"

fragment ZoomMeetingTimelineFragment on ExternalMeeting {
    id
    topic
    serviceType
    transcript
    transcriptStatus
    recordingUrl
    recordingStatus
    transcriptionSummary {
        ...EntitySummaryFragment
    }
    startTime
    participants {
        name
    }
    durationMinutes
}
